(function()
{
	var Application = include('springroll.Application');
	var Debug = include('springroll.Debug', false);
	var Mode = include('nature.enum.Mode');

	var JUMP_X = 100;

	var _app;
	var _camera;
	var _entryExitSpeed;
	var _hasJumped;
	var _origX;
	var _panel;
	var _rideTime;
	var _rideTimer;

	/**
	 * @param {PIXI.Container} panel
	 */
	var Hal = function(panel)
	{
		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		_app = Application.instance;

		_panel = panel;
		_camera = panel.camera;

		var configHal = _app.config.hal;
		_entryExitSpeed = configHal.entryExitSpeed;
		_rideTime = configHal.rideTime;

		this.y = configHal.y;
		this.framerate = 30;
		this.visible = false;

		// copy the info of the ridePositionReference clip with this (Hal) clip
		this.firstFrameY = this.ridePositionReference.y;

		// Save methods as own property instead of prototype property
		// for better speed when we are calling it a ton
		this.move = this.move;
		this.start = this.start;
	};

	var s = pixiflash.MovieClip.prototype;
	var p = Hal.prototype;

	p.start = function()
	{
		this.visible = true;
		this.x = _origX = _camera.viewport.left - 400;
		_panel.worldContainer.addChildAt(this, 0);

		_hasJumped = false;
		_rideTimer = null;
		_app.sound.play('HalApproaching');
		_app.animator.play(this, 'run');
	};

	p.move = function(elapsed)
	{
		var delta = elapsed * 0.001;
		// Hal needs to enter the screen from the left, so 
		// his speed needs to be greater than the seed's default 
		this.speed = _entryExitSpeed;
		if (!_hasJumped && this.x - _origX >= JUMP_X)
		{
			_app.animator.play(this, 'jump', function()
			{
				_rideTimer = _rideTime;
				_panel.seedContainer.mode = Mode.Riding;
				_app.animator.play(this, 'run');
				_app.sound.play('HalRunningLoop',
				{
					loop: true
				});
			}.bind(this));
			_hasJumped = true;
			_panel.seedContainer.mode = Mode.BeingCaught;
		}

		if (_panel.seedContainer.mode == Mode.Riding && _rideTimer)
		{
			_rideTimer -= elapsed;
			if (_rideTimer <= 0)
			{
				_rideTimer = null;
				// Make the seeds lift off
				_panel.seedContainer.mode = Mode.Tweening;
				_panel.seedContainer.moveOffHal();
			}
		}
		// Move the Hal clip 
		this.x += this.speed * delta;
	};

	/**
	 * @param {Number} elapsed
	 */
	p.update = function(elapsed)
	{
		if (this.visible)
		{
			this.move(elapsed);
			if (this.x >= _camera.viewport.right)
			{
				this.visible = false;
			}
		}
	};

	/**
	 * destroy and don't use after this
	 * @method destroy
	 */
	p.destroy = function()
	{
		s.destroy.call(this); 
		
		this.move = null;
		this.start = null;

		_app = null;
		_camera = null;
		_entryExitSpeed = null;
		_hasJumped = null;
		_origX = null;
		_panel = null;
		_rideTime = null;
		_rideTimer = null;
	};

	namespace('nature').Hal = Hal;
}());